<template>
  <div class="FilterTag" :class="[filter.shortname, { hide: filter.name.length < 2 }]">
    <span v-if="(filter.shortname === 'dateRangeFilterTag') && ((dateFilterFrom !== null && this.dateFilterFrom !== '') || (dateFilterTo !== null && this.dateFilterTo !== ''))">
      <template v-if="dateFilterFrom"> from {{ dateFilterFrom|truncate(4,'') }} </template>
      <template v-if="dateFilterTo">to {{ dateFilterTo|truncate(4,'') }}</template>
    </span>
    <span v-else>{{ filter.name }}</span>
    <span class="close" @click="removeFilterTag()">
      <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs></defs>
          <g id="home-and-interior" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="search---results---list" transform="translate(-147.000000, -406.000000)" fill="#FFFFFF">
                  <g id="Group-3" transform="translate(25.000000, 398.000000)">
                      <path d="M135.818652,19.7760417 C135.915372,19.8732644 135.96373,19.994791 135.96373,20.140625 C135.96373,20.286459 135.915372,20.4079856 135.818652,20.5052083 L134.440414,21.8541667 C134.343695,21.9513894 134.234889,22 134.113989,22 C133.968912,22 133.848014,21.9513894 133.751295,21.8541667 L129,17.078125 L124.248705,21.8541667 C124.151986,21.9513894 124.043179,22 123.92228,22 C123.777202,22 123.656305,21.9513894 123.559586,21.8541667 L122.181348,20.5052083 C122.084629,20.4079856 122.03627,20.286459 122.03627,20.140625 C122.03627,19.994791 122.084629,19.8732644 122.181348,19.7760417 L126.968912,15 L122.181348,10.2604167 C121.939551,10.0173603 121.939551,9.77430633 122.181348,9.53125 L123.523317,8.14583333 C123.668395,8.04861033 123.789292,8 123.886011,8 C124.031089,8 124.151986,8.04861033 124.248705,8.14583333 L129,12.8854167 L133.751295,8.14583333 C133.896373,8.04861033 134.01727,8 134.113989,8 C134.259067,8 134.379964,8.04861033 134.476684,8.14583333 L135.818652,9.53125 C136.060449,9.77430633 136.060449,10.0052083 135.818652,10.2239583 L131.031088,14.9635417 L135.818652,19.7760417 Z" id="Fill-1"></path>
                  </g>
              </g>
          </g>
      </svg>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'FilterTag',
  props: ['filter'],
  methods: {
    removeFilterTag: function () {
      this.$store.commit('updateCurrentPage', 1)
      if (this.filter.shortname === 'dateRangeFilterTag') {
        this.$store.commit('updateDateFilterFrom', null)
        this.$store.commit('updateDateFilterTo', null)
        this.$store.commit('updateActiveFilters', this.activeFilters)
        this.broadcast('filter-tag-removed', this.filter.shortname)
        this.broadcast('requery')
        this.broadcast('reset-date-values')
      } else {
        var filters = this.activeFilters
        var index = filters.indexOf(this.filter)
        filters.splice(index, 1)
        this.$store.commit('updateActiveFilters', filters)
        this.broadcast('filter-tag-removed', this.filter.shortname)
      }

      if (this.filter.kind === 'states') {
        this.broadcast('reset-state-value')
      }

      if (this.filter.kind === 'key_person') {
        this.broadcast('reset-person-value')
      }


    }
  },
  mounted: function () {
    // console.log(this.filter)
  },
  computed: {
    ...mapGetters({
      activeFilters: 'getActiveFilters',
      dateFilterFrom: 'getDateFilterFrom',
      dateFilterTo: 'getDateFilterTo',
    })
  }
};
</script>

<style scoped lang="scss">
.FilterTag {
  color: white;
  background: $pink;
  font-size: 16px;
  font-weight: bold;
  display: inline-block;
  padding: 8px;
  margin-right: 8px;
  margin-bottom: 8px;

  svg {
    position: relative;
    top: 2px;
    margin-left: 8px;
  }
}
</style>
